import ShotProfileCell from "./ShotProfileCell";

export default ShotProfileCell;
